module.exports = __webpack_public_path__ + "static/order-centered-c4e2e4f77253de2961ea4ffbce529e63.png";